import { render, staticRenderFns } from "./urlmap.vue?vue&type=template&id=9d253392&scoped=true&"
import script from "./urlmap.vue?vue&type=script&lang=js&"
export * from "./urlmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d253392",
  null
  
)

export default component.exports